import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, RouterEvent, Event , Router, NavigationEnd} from '@angular/router';
import { routerNgProbeToken } from '@angular/router/src/router_module';
import { filter } from 'rxjs/internal/operators/filter';
import { UnsubModel } from './unsub.model';
import { UnsubService } from './unsub.service';

@Component({
  selector: 'app-unsub-details',
  templateUrl: './unsub-details.component.html',
  styleUrls: ['./unsub-details.component.css']
})
export class UnsubDetailsComponent implements OnInit {

  
  unsub: UnsubModel[];
  unsubId: Number;
  isDeleted: boolean;
  deletedMessage:string = "The unsub has been deleted";
  notFoundMessage:string = "Unsub not found";
  constructor(private unsubService:  UnsubService,private route: ActivatedRoute ,public router:Router){
    this.unsubId = route.snapshot.params.id;

    
  }
  ngOnInit() {
    /* //This does not work correctly
    this.router.events.pipe(filter((e: Event): e is RouterEvent => e instanceof NavigationEnd)
    ).subscribe((e: RouterEvent) => {
      console.log("URL was changed");
      console.log(e);
      this.router.navigateByUrl(e.url);
      console.log("OK we should be re routed");
    });
    */
    console.log("Need to fetch:" + this.unsubId);
    this.isDeleted = false;
    this.unsubService.getUnsub(this.unsubId).subscribe(unsub => {
        this.unsub = unsub;  
      })
  }
  delete() {
    console.log("Ok let's delete unsub "+ this.unsubId);
    this.unsubService.deleteUnsub(this.unsubId).subscribe(unsub => {
      this.unsub = unsub;  
      this.isDeleted = true;
    })
  }

}
